import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initViewportHeight } from './lib/viewport'
import { getApiBaseUrl, API_ENV } from './config'

// Initialize viewport height handling for mobile devices
initViewportHeight();

// Log active API base URL on startup (visible in browser console)
console.log(`[API] Environment: ${API_ENV} | Base URL: ${getApiBaseUrl()}`);

createRoot(document.getElementById("root")!).render(<App />);
